(function () {
	'use strict';
	angular.module('app.setup')
		.controller('leanSyncConfigTableMappings', leanSyncConfigTableMappings);

	leanSyncConfigTableMappings.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'leanSyncConfigService', 'tableNdx', 'tableName', 'config', 'storeService'];

	function leanSyncConfigTableMappings($rootScope, $scope, $uibModalInstance, leanSyncConfigService, tableNdx, tableName, config, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		// Temporary Undefined Value until Backend Change
		var tempUndefined = 26;
		vm.tableNdx = tableNdx;
		vm.tableName = tableName;
		vm.table = config.data;
		vm.lastModified = config.lastModified;
		vm.columnChoices = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
			18, 19, 20, 21, 22, 23, 24, 25, 'undefined'
		];
		vm.isEnabled = ['No', 'LeanSync', 'LeanLoad'];


		vm.booleanValues = [{
			name: 'Yes',
			value: true
		},
		{
			name: 'No',
			value: false
		}
		];
		// view model functions
		vm.save = save;
		vm.close = close;
		vm.fieldName = fieldName;

		function init() {
			_.forEach(vm.table.mappings, function (value, key) {
				if (value.columnNumber === tempUndefined) {
					value.columnNumber = 'undefined';
				}
			});
		}

		/**
		 * Saves Mappings to Server
		 * If duplicates are found, applies red border to culprits and toasts
		 *
		 */
		function save() {
			// Remove error classes if they exist
			jQuery('.fields button').removeClass('error-border');
			var mappingsForSave = angular.copy(vm.table);
			for (var i=0; i < mappingsForSave.mappings.length; i++) {
				if (mappingsForSave.mappings[i].columnNumber === 'undefined') {
					mappingsForSave.mappings[i].columnNumber = tempUndefined;
				}
			}
			leanSyncConfigService.saveMappingsForTable(vm.tableNdx, mappingsForSave, vm.lastModified, adminConfig.factory.id).then(function (message) {
				$uibModalInstance.close('ok');
			});
		}

		function close() {
			$uibModalInstance.dismiss('cancel');
		}

		function fieldName(field) {
			var fieldName = field.fieldName.replace(/\s+/g, '');
			return fieldName;
		}

		init();
	}
})();
